/**
 * created by wang lei
 xxxxx页面
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../../../../../base/BaseComponent";
import MediaSelect from "../../../../../publishStatistics/component/MediaSelect";
import {getInfoFromLocalStorage} from "../../../../../../../actions";

export default class Sta_mediaSelect extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            mediaList:[]
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        let deptIds =[getInfoFromLocalStorage("currentUser").defaultInfo.dept.id]
        this.getMedia(deptIds)
        if(this.props.config.defaultDept){
            this.props.onChange({labelCode:"deptIds",val:deptIds.toString()})
        }
    }

    render() {
        const {
            value,
            onChange,
            config = {},
            labelCode,
            size,
            disabled,
            id,
            placeholder,
        } = this.props
        const {style={},maxTagCount} = config;
        return (
            <div>
                <MediaSelect mediaList={this.state.mediaList}
                             placeholder={placeholder}
                             style={style}
                             size={size}
                             disabled={disabled}
                             id={id}
                             checkMedia={(value) => {
                                 console.log(value)
                                 onChange({labelCode, val: value.toString()})
                             }}
                             value={value}
                             maxTagCount={maxTagCount}
                             statisticsTable={true}
                />
            </div>
        )
    }

    //根据单位获取媒体
    getMedia = (value) => {
        this.request({
            url: "/cm-sites-pms/media/getMediaByDeptIds",
            method: 'post',
            contentType: 'json',
            body: value,
            callBack: (res) => {
                let mediaList = [];
                if (res) {
                    mediaList = res
                }
                this.setState({mediaList})
            }
        })
    };
}